
import Footer from "@/components/layout/navigation/Footer"
import DetailsPageToolbar from "@/components/job/jobdetailcard/DetailsPageToolbar"
import { mapState, mapGetters } from "vuex"
import defaultMeta from "@/mixins/defaultMeta"

export default {
    name: "DetailPageLayout",
    components: {
        DetailsPageToolbar,
        Footer,
        ProgressCircular: () => import("@/components/base/ProgressCircular"),
        Login: () => import("@/components/auth/Login"),
        CookieInformation: () =>
            import("@/components/layout/CookieInformation"),
        ImpersonateHeader: () => import("@/components/admin/ImpersonateHeader"),
    },
    mixins: [defaultMeta],
    data() {
        return {}
    },
    computed: {
        ...mapGetters("ui", ["loadingSpinner"]),
        ...mapState({
            showCookieConsent: (state) => state.cookie.showCookieConsent,
        }),
        ...mapGetters("meta", ["meta"]),
        showFooter() {
            return !this.meta.footer?.hidden && !this.$auth.loggedIn
        },
        showToolbar() {
            const isJobPage = this.$route.name === "betriebe-slug-jobs-jobSlug"
            return !isJobPage
        },
    },
    mounted() {
        this.$store.dispatch("chat/initialize")
    },
}
